import dayjs, { Dayjs } from 'dayjs';
import { TimeActive, RangeValue } from './type';
import { message } from '@maxtropy/components';

export const recent5Weeks = () => {
  const endDate = dayjs().endOf('week');
  const startDate = dayjs().subtract(4, 'week').startOf('week');
  return [startDate, endDate] as RangeValue;
};

export const onChangePicker = (
  dates: RangeValue,
  activeKey: TimeActive,
  setValue: React.Dispatch<React.SetStateAction<RangeValue>>
) => {
  let isFlag = true;
  switch (activeKey) {
    case TimeActive.THIS_MONTH:
      if (dates?.[0] && dates?.[1] && dates?.[0].add(12, 'month').valueOf() < dates?.[1].valueOf()) {
        isFlag = false;
        message.error('最多选择12个月');
      }
      break;
    case TimeActive.THIS_WEEK:
      if (dates?.[0] && dates?.[1] && dates?.[0].add(52, 'week').valueOf() < dates?.[1].valueOf()) {
        message.error('最多选择52周');
        isFlag = false;
      }
      break;
    case TimeActive.CUSTOM:
      if (dates?.[0] && dates?.[1] && dates?.[0].add(1, 'year').valueOf() < dates?.[1].valueOf()) {
        message.error('最多选择1年');
        isFlag = false;
      }
      break;
  }
  if (isFlag) {
    setValue(dates);
  }
};

export const disableFlowDate = (current: Dayjs, flowRangeValue: [Dayjs, Dayjs]) => {
  if (!current) return false;
  // 禁用未来日期
  if (current > dayjs().startOf('day')) {
    return true;
  }
  // 如果已选择了开始日期，限制结束日期不能超过31天
  if (flowRangeValue[0] && !flowRangeValue[1]) {
    const startDate = flowRangeValue[0];
    const diffDays = current.diff(startDate, 'days');
    return Math.abs(diffDays) > 30;
  }
  return false;
};

export const TimePickerUtil = (activeKey: TimeActive) => {
  if (activeKey === TimeActive.THIS_MONTH) {
    return 'month';
  } else if (activeKey === TimeActive.THIS_WEEK) {
    return 'week';
  } else if (activeKey === TimeActive.CUSTOM) {
    return 'date';
  } else {
    return 'month';
  }
};

export const defaultNodeRangeValue = (
  activeKey: TimeActive,
  setNodeRangeValue: React.Dispatch<React.SetStateAction<RangeValue>>
) => {
  if (activeKey === TimeActive.CUSTOM) {
    // 近31天，不包括当天
    const end = dayjs().subtract(1, 'day').endOf('day');
    const start = end.clone().subtract(30, 'day').startOf('day');
    setNodeRangeValue([start, end]);
  } else if (activeKey === TimeActive.THIS_WEEK) {
    // 近5周
    const end = dayjs().endOf('week');
    const start = end.clone().subtract(4, 'week').startOf('week');
    setNodeRangeValue([start, end]);
  } else if (activeKey === TimeActive.THIS_MONTH) {
    // 近6月
    const end = dayjs().endOf('month');
    const start = end.clone().subtract(5, 'month').startOf('month');
    setNodeRangeValue([start, end]);
  }
};
